/* eslint-disable react/display-name */
import React, { forwardRef } from 'react'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import {
    DateTimeFieldExtendedState,
    DateTimeFieldProps,
    DateTimeValue,
} from './DateTimeField'
import { DisplayErrors } from '../BaseDisplayItem'

export interface DateTimeFieldEditProps {
    kedo: DateTimeFieldProps['kedo']
    state: DateTimeFieldExtendedState
    value: DateTimeValue
    errors?: DisplayErrors
    onChangeDate: (
        moment: moment.Moment | null,
        name?: string,
        searchType?: string
    ) => void
    isInvalid: () => boolean
    getErrorText: () => string
    getCurrentLocale: () => string
}

export const DateTimeFieldEdit = forwardRef<
    HTMLDivElement,
    DateTimeFieldEditProps
>(({ kedo, state, value, errors, onChangeDate, isInvalid }, ref) => {
    const date =
        value !== null && value !== undefined
            ? moment(value.toLocaleString())
            : null

    return (
        <div ref={ref}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                    label={kedo.t('select_date_time')}
                    value={date}
                    onChange={(momentValue) => {
                        onChangeDate?.(momentValue)
                    }}
                    format={state.withtime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY'}
                    views={
                        state.withtime
                            ? ['year', 'month', 'day', 'hours', 'minutes']
                            : ['year', 'month', 'day']
                    }
                    slotProps={{
                        textField: {
                            error: isInvalid(),
                            helperText: isInvalid() ? errors : null,
                            fullWidth: true,
                        },
                        field: {
                            clearable: true,
                        },
                    }}
                    disableFuture={
                        state.restriction === 'before_and_eq_current_date'
                    }
                    disablePast={
                        state.restriction === 'after_and_eq_current_date'
                    }
                />
            </LocalizationProvider>
        </div>
    )
})
